// SPDX-License-Identifier: AGPL-3.0-or-later

import {makeAutoObservable, runInAction} from 'mobx';

const CONNECT_THROTTLE_MS = 1000;

export interface ConnectionThrottleState {
	lastConnectRequestAt: number | null;
	connectAttemptId: number;
	inFlightConnect: boolean;
}

const initialThrottleState: ConnectionThrottleState = {
	lastConnectRequestAt: null,
	connectAttemptId: 0,
	inFlightConnect: false,
};

export class VoiceConnectionThrottle {
	throttleState: ConnectionThrottleState = initialThrottleState;

	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
	}

	get connectAttemptId(): number {
		return this.throttleState.connectAttemptId;
	}

	get inFlightConnect(): boolean {
		return this.throttleState.inFlightConnect;
	}

	shouldThrottle(): boolean {
		const now = Date.now();
		const last = this.throttleState.lastConnectRequestAt ?? 0;
		return now - last < CONNECT_THROTTLE_MS;
	}

	isLatestAttempt(id: number): boolean {
		return id === this.throttleState.connectAttemptId;
	}

	recordConnectRequest(): void {
		runInAction(() => {
			this.throttleState = {
				...this.throttleState,
				lastConnectRequestAt: Date.now(),
			};
		});
	}

	incrementAttemptId(): void {
		runInAction(() => {
			this.throttleState = {
				...this.throttleState,
				connectAttemptId: this.throttleState.connectAttemptId + 1,
			};
		});
	}

	setInFlightConnect(value: boolean): void {
		runInAction(() => {
			this.throttleState = {
				...this.throttleState,
				inFlightConnect: value,
			};
		});
	}

	reset(): void {
		runInAction(() => {
			this.throttleState = initialThrottleState;
		});
	}
}
